import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Dashboard from "@/pages/Dashboard";
import BotWorkspace from "@/pages/BotWorkspace";
import OrgView from "@/pages/OrgView";
import OrgSettings from "@/pages/OrgSettings";
import AgentStudio from "@/pages/AgentStudio";

// UBM Module Pages
import UBMBills from "@/pages/modules/ubm/Bills";
import UBMVendors from "@/pages/modules/ubm/Vendors";
import UBMAccounts from "@/pages/modules/ubm/Accounts";
import UBMTestResults from "@/pages/modules/ubm/TestResults";

function App() {
  return (
    <div className="App min-h-screen bg-zinc-950">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/bot/:botId" element={<BotWorkspace />} />
          
          {/* Organization Routes */}
          <Route path="/org/:orgId" element={<OrgView />} />
          <Route path="/org/:orgId/settings" element={<OrgSettings />} />
          <Route path="/org" element={<OrgView />} />
          
          {/* Agent Studio Routes */}
          <Route path="/studio" element={<AgentStudio />} />
          <Route path="/studio/:agentId" element={<AgentStudio />} />
          
          {/* UBM Module Routes */}
          <Route path="/org/:orgId/ubm/bills" element={<UBMBills />} />
          <Route path="/org/:orgId/ubm/vendors" element={<UBMVendors />} />
          <Route path="/org/:orgId/ubm/accounts" element={<UBMAccounts />} />
          <Route path="/org/:orgId/ubm/test-results" element={<UBMTestResults />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
}

export default App;
